import userAuthenticationApi from "services/api/user/userAuthenticationApi";
import { useGetApi } from "../hooks";

export const useGetMyProfile = ({ enabled, onSuccess, onError } = {}) =>
  useGetApi({
    fetch: () => userAuthenticationApi.getMyProfile(),
    key: ["userAuthenticationApi.getMyProfile"],
    enabled,
    onSuccess,
    onError
  });
